import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Alert from '../components/common/Alert';

const LoginPage = () => {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const { login } = useAuth();
	const navigate = useNavigate();
	const baseUrl = process.env.REACT_APP_BASE_URL || '/';

	const handleSubmit = async (e) => {
		e.preventDefault();
		const success = await login(username, password);

		/*if (success) {
			navigate(`${baseUrl}admin`);
		}*/
	};

	return (
		<div className="container">
			<Alert />
			<div className="row justify-content-center align-items-center min-vh-100">
				<div className="col-md-4">
					<div className="card">
						<div className="card-body">
							<form onSubmit={handleSubmit}>
								<div className="form-group">
									<label htmlFor="username">Username</label>
									<input
										type="text"
										className="form-control"
										id="username"
										value={username}
										onChange={(e) => setUsername(e.target.value)}
										required
									/>
								</div>
								<div className="form-group">
									<label htmlFor="password">Password</label>
									<input
										type="password"
										className="form-control"
										id="password"
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										required
									/>
								</div>
								<button type="submit" className="btn btn-primary btn-block">
									Login
								</button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default LoginPage;
